module.exports = __webpack_public_path__ + "img/T6-D-xh_0.33ddb676.png";